export function getFilterText(e, state) {
  const text = e.target.value ? e.target.value : '';
  state.setState({ filterText: text });
}
